import mdl from '@/models/Accounting/AccAccountingSeat'

const createAccountingSeat = async data => {
    let seat = new mdl(data)
    try {
        let response = await seat.save()
        return response
    } catch (error) {
        return error.response
    }
}

export { createAccountingSeat }
